import type { ReactNode } from "react"
import { useEffect } from "react"
import type { IPublicClientApplication } from "@azure/msal-browser"
import { EventType } from "@azure/msal-browser"

type AuthNavigationProps = {
  children: ReactNode
  instance: IPublicClientApplication
}

function AuthNavigation(props: AuthNavigationProps) {
  const { children, instance } = props

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      // Handle successful login - set active account
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload
      ) {
        const accounts = instance.getAllAccounts()
        if (accounts.length > 0) {
          instance.setActiveAccount(accounts[0])
        }
      }
    })

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId)
      }
    }
  }, [instance])

  return <>{children}</>
}

export default AuthNavigation
